import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAnalytics from 'vue-analytics'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle, faChevronLeft, faArrowCircleRight, faSmileBeam } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false
Vue.use(BootstrapVue);
[faTimesCircle, faChevronLeft, faArrowCircleRight, faSmileBeam ].forEach(icon => library.add(icon));

Vue.use(VueAnalytics, {
  id: 'UA-146618357-2'
})

Vue.component('fa-icon', FontAwesomeIcon)

new Vue({
  render: h => h(App),
}).$mount('#app')
